import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { getAdminStats } from '../../../../services/userservice';

const Dashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getAdminStats();
        setData(data);
      } catch (error) {
        console.error('Error fetching admin stats:', error);
      }
    };

    fetchStats();
  }, []);

  const stats = [
    { label: 'Candidatos', count: data.employees},
    { label: 'Empresas', count: data.companies },
    { label: 'Ofertas de trabajo', count: data.job_offers},
  ];

  return (
    <div className="g-4 pt-4">
      {stats.map((stat, index) => (
        <div key={index} md={4} className="mb-4">
          <Card className="border-0 shadow-sm py-5 text-center h-100">
            <CardBody className="d-flex flex-column align-items-center justify-content-center">
              <h2 className="display-4 fw-bold mb-0">{stat.count}</h2>
              <p className="text-muted text-lg mb-0">{stat.label}</p>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default Dashboard;